import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HeroBlock1 } from "./HeroBlock1";
import { HeroBlock2 } from "./HeroBlock2";
import { HeroBlock3 } from "./HeroBlock3";
import { HeroBlock4 } from "./HeroBlock4";
import { HeroBlock5 } from "./HeroBlock5";
import { HeroBlock6 } from "./HeroBlock6";

export const heroBlocks: BlockExportMapping = {
  HeroBlock1,
  HeroBlock2,
  HeroBlock3,
  HeroBlock4,
  HeroBlock5,
  HeroBlock6,
};
